<div class="card" style="position: relative">
    <p-toast></p-toast>
    <span class="page-title"><i class="pi pi-building page-title-icon"></i>Bank Management</span>
    <div class="mt-6">
        <p-tabView class="pt-8">

            <p-tabPanel header="Bank Mapping">
                <div class="info-banner">
                    <i class="pi pi-info-circle info-banner-icon"></i>
                    <small>Map each column in your bank's statement file to the corresponding data field. Set the number of header rows to skip and assign a zero-based column index to each field so the importer knows where to find transaction data.</small>
                </div>

                <!-- Setup: Bank + Headers to Skip -->
                <div class="controls-wrapper">
                    <div class="dropdown-wrapper">
                        <label class="ctrl-label">Bank <span class="text-red-500">*</span></label>
                        <p-dropdown [options]="banks" [(ngModel)]="mappingBank" placeholder="Select Bank"
                            optionLabel="label" optionValue="value"></p-dropdown>
                    </div>
                    <div class="numeric-wrapper">
                        <label class="ctrl-label">Headers to Skip</label>
                        <p-inputNumber [(ngModel)]="headersToSkip" [min]="0"
                            [showButtons]="false" inputStyleClass="input-fixed"></p-inputNumber>
                    </div>
                </div>

                <!-- Column Mapping table -->
                <div class="mapping-scroll">
                <div class="mapping-section">
                    <div class="mapping-header-row">
                        <span class="mapping-col-num">#</span>
                        <span class="mapping-col-name">Column Name</span>
                        <span class="mapping-col-index">Column Index</span>
                        <span class="mapping-col-action"></span>
                    </div>

                    @for (row of mappingRequests(); track row; let i = $index) {
                        <div class="mapping-entry">
                            <span class="mapping-col-num mapping-entry-num">{{ i + 1 }}</span>
                            <div class="mapping-col-name">
                                <p-dropdown [options]="columnNameOptions" [(ngModel)]="row.columnName"
                                    placeholder="Select column" optionLabel="label" optionValue="value"></p-dropdown>
                            </div>
                            <div class="mapping-col-index">
                                <p-inputNumber [(ngModel)]="row.columnIndex" placeholder="0"
                                    [min]="0" [showButtons]="false"
                                    inputStyleClass="text-center"></p-inputNumber>
                            </div>
                            <div class="mapping-col-action">
                                @if (mappingRequests().length > 1) {
                                    <p-button icon="pi pi-trash" (onClick)="removeMappingRow(i)"
                                        [text]="true" severity="danger" pTooltip="Remove" size="small"></p-button>
                                }
                            </div>
                        </div>
                    }

                    <div class="mapping-actions">
                        <p-button label="Add Column" icon="pi pi-plus" (onClick)="addMappingRow()"
                            [text]="true" [raised]="true" size="small"></p-button>
                        <p-button label="Save Mapping" icon="pi pi-check" (onClick)="submitBankMapping()"
                            [disabled]="!mappingBank || savingMapping()" [loading]="savingMapping()"
                            [text]="true" [raised]="true" severity="success">
                        </p-button>
                    </div>
                </div>
                </div>
            </p-tabPanel>

            <p-tabPanel header="Statement Imports">
                <div class="info-banner">
                    <i class="pi pi-info-circle info-banner-icon"></i>
                    <small>Upload a CSV or Excel bank statement to import transactions into the system. Select the bank and currency before importing. Imported transactions will appear in the reconciliation queue for allocation.</small>
                </div>
                <div class="controls-wrapper">
                    <div class="dropdown-wrapper">
                        <label class="ctrl-label">Bank</label>
                        <p-dropdown [options]="banks" [(ngModel)]="importBank" placeholder="Select Bank"
                            optionLabel="label" optionValue="value"></p-dropdown>
                    </div>
                    <div class="dropdown-wrapper">
                        <label class="ctrl-label">Currency</label>
                        <p-dropdown [options]="currencies()" [(ngModel)]="importCurrencyId"
                            placeholder="Select Currency" optionLabel="code" optionValue="id"
                            [loading]="loadingCurrencies()"></p-dropdown>
                    </div>
                </div>
                <div class="file-upload-wrapper">
                    <p-fileUpload #fileUpload mode="advanced" chooseLabel="Choose Statement"
                        chooseIcon="pi pi-upload" maxFileSize="10000000" [customUpload]="true"
                        (onSelect)="onFileSelect($event)" accept=".csv,.xls,.xlsx"
                        [showUploadButton]="false" [showCancelButton]="false">
                    </p-fileUpload>
                </div>
                <div class="page-actions-wrapper">
                    <p-button label="Import Statement" icon="pi pi-check" (onClick)="submitStatementImport()"
                        [disabled]="!importBank || !importCurrencyId || !selectedFile || importing()"
                        [loading]="importing()" [text]="true" [raised]="true" severity="success">
                    </p-button>
                </div>
            </p-tabPanel>

        </p-tabView>
    </div>
</div>
